module.exports = __webpack_public_path__ + "media/mourning-dove-1.2dfbc103.mp3";